module.exports = __webpack_public_path__ + "static/media/technical-support.9ed1d57d.svg";